import React from 'react';
import TextComponent from 'shared/components/TextComponent';
import { arrayY } from 'shared/data/tooltips';

const ArrayY = (props) => {
  const name = 'array_y';
  const {
    parameters,
    errorMessage,
    label,
    inputId,
    required,
    onChangeParameter,
    groupName,
    className,
    inputClassName,
    tooltip,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <TextComponent
      label={label}
      name={name}
      value={parameters[name] || ''}
      onChange={onChange}
      tooltip={tooltip}
      groupName={groupName}
      errorMessage={errorMessage}
      inputId={inputId}
      required={required}
      type="number"
      className={className}
      inputClassName={inputClassName} />
  );
};

ArrayY.defaultProps = {
  label: 'Array Overall Width (inches)',
  tooltip: arrayY,
};

export default ArrayY;

